import React from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'

import Header from '../shared/Header'
import { media } from '../utils/style-utils'

const Container = styled.div`
  background-color: ${props => props.theme.colors.azure};
  
  width: 100%;
  display: grid;
  place-items: center;

  ${media.small`
    padding: 70px 20px 55px 20px;
  `}
  ${media.medium`
    padding: 100px 40px 55px 40px;
  `}
  ${media.large`
    padding: 90px 40px;
  `}
`

const query = graphql`
  query {
    image: file(relativePath: { regex: "/careers/careers-hero.jpeg/" }) {
      childImageSharp {
        fluid(maxWidth: 1700) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

const AboveTheFold = () => {
  const { image } = useStaticQuery(query)

  const headerConfig = {
    header: 'Get on board',
    subheader:
      'Great ideas are nothing without a great team to bring them to life',
    image: { fluid: image.childImageSharp.fluid, alt: 'ID team members' },
    centered: true,
  }

  return (
    <Container>
      <Header config={headerConfig} />
    </Container>
  )
}

export default AboveTheFold
